import { EmployeeAbsenceTypeModelType } from '@teinor/erp/types/company/userInner/employee/employeeAbsence/employeeAbsenceType'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'

interface ModalCEExpenseTypeProps extends ModalEditComponentProps { }

const ModalCEExpenseType: React.FC<ModalCEExpenseTypeProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<EmployeeAbsenceTypeModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/employeeExpense/updateEmployeeExpenseRowType'} translations={{ title: t('editEmployeeExpenseType', 'Editar tipo de gasto'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest}></LittleModalCreateEdit>)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/employeeExpense/createEmployeeExpenseRowType'} translations={{
        title: t('createExpenseType', 'Crear tipo de gasto'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEExpenseType